import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'cep' })
export class CepPipe implements PipeTransform {

    public transform(value: any): any {
        value = value.toString();

        const first = value.slice(0, value.length - 3);
        const last = value.substr(value.length - 3);

        return `${first}-${last}`;
    }
}
